<template>
    <el-form v-if="model"
             ref="form"
             :model="model"
             :rules="rules"
             :label-position="labelPosition"
    >

        <el-form-item label="限制类型">
            <el-radio-group v-model="model.type">
                <el-radio v-for="(name, key) in allow_types" :label="parseInt(key)" :key="key">{{name}}</el-radio>
            </el-radio-group>
        </el-form-item>

        <el-form-item v-if="model.type == 1 && users.length > 0" label="请选择要限制的用户">
            <el-select v-model="model.allow_range" filterable multiple placeholder="请选择" style="width:100%">
                <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item v-if="model.type == 2 && branches.length > 0" label="请选择要限制部门">
            <el-select v-model="model.allow_range" multiple placeholder="请选择" style="width:100%">
                <el-option
                        v-for="item in branches"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item v-if="model.type == 3 && roles.length > 0" label="请选择要限制的职位">
            <el-select v-model="model.allow_range" multiple placeholder="请选择" style="width:100%">
                <el-option
                        v-for="item in roles"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="限制允许登录时间">

            <template v-if="model.allow_times">
                <div>
                    <el-checkbox-group v-model="checkedTimes">
                        <el-checkbox-button v-for="(time, key) in weekTimes" :label="key" :key="key">
                            {{getWeekName(key)}}
                        </el-checkbox-button>
                    </el-checkbox-group>
                </div>
            </template>

            <el-alert title="温馨提示: 如果不设置限制时间段请留空不选" type="info"></el-alert>
            <hr color="#FFFFF"/>
            <template v-for="(time, key) in model.allow_times">
                <!--<el-checkbox :label="getWeekName(key)"></el-checkbox>-->
                {{getWeekName(key)}}
                &nbsp;
                <el-time-select
                        placeholder="起始时间"
                        v-model="time.start_at"
                        :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '24:00'
                    }">
                </el-time-select>

                <el-time-select
                        placeholder="结束时间"
                        v-model="time.end_at"
                        :picker-options="{
                            start: '08:30',
                            step: '00:15',
                            end: '24:00',
                            minTime: time.start_at
                    }">
                </el-time-select>
                <hr color="#FFFFF"/>
            </template>
        </el-form-item>

        <el-form-item label="限制允许登录IP (最多输入20个，如不限制可不填)">
            <el-select
                    v-model="model.allow_ips"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    style="width:100%"
                    :multiple-limit="20"
                    auto-complete="On"
                    placeholder="请输入需要限制的IP"
            >
            </el-select>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="submitForm()">立即保存</el-button>
        </el-form-item>

    </el-form>
</template>

<script>
    import {
        LoginRuleService,
        TYPE_USERS,
        TYPE_BRANCHES,
        TYPE_ROLE
    } from "~/services/LoginRule"
    import UserService from "~/services/user";
    import CommonService from "~/services/common";

    export default {
        name: "loginRuleForm",
        props: {
            model: {
                type: Object,
                required: true
            },
            scenario: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                labelPosition: 'top',
                weekTimes: [],
                // 选中的时间段
                checkedTimes: [],
                allow_types: {},
                // 需要限制用户时供选择的用户列表
                users: [],
                // 需要限制部门时供选择的部门列表
                branches: [],
                // 需要限制职位时供选择的职位列表
                roles: [],
                rules: {
                    type: [
                        {
                            required: true,
                            message: "请正确选择限制对象",
                            trigger: "blur"
                        },
                    ]
                },
            };
        },

        watch: {
            checkedTimes: function (val, origin) {
                let _allowTimes = this.scenario == 'create' ? {} : this.model.allow_times;
                let allowTimes = {};
                let weekTimes = this.weekTimes;
                if (val.length > 0) {
                    val.forEach(function (week) {
                        if (!_allowTimes[week]) {
                            allowTimes[week] = weekTimes[week]
                        } else {
                            allowTimes[week] = _allowTimes[week]
                        }
                    });
                }
                this.model.allow_times = allowTimes;
            },

            'model.type': function(val, origin) {
                // 在编辑模式下如果有切换类型则需要将原来选中的 allow_range 清空
                if (this.scenario == 'update' && val != origin) {
                    this.clearAllowRange();
                }

                this.getSelectOptions(val);
            }
        },

        created() {
            if (this.weekTimes.length < 1) {
                //this.weekTimes = LoginRuleService.getWeekTimes();
                this.initWeekTimes();
            }

            this.allow_types = this.getAllowTypes();

            if (this.model.id > 0) {
                this.getSelectOptions(this.model.type)
                if (this.model.allow_times) {
                    for (var i in this.model.allow_times) {
                        this.checkedTimes.push(i);
                    }
                }
            }

        },

        methods: {

            /**
             * 初始化周次列表
             */
            initWeekTimes() {
                let weekTimes = LoginRuleService.getWeekTimes();
                let data = {};
                for (var key in weekTimes) {
                    data[key] = {start_at: "", end_at: ""};
                }

                this.weekTimes = data;
            },

            /**
             * 得到周次名称
             * @param key
             * @returns {*}
             */
            getWeekName(key) {
                return LoginRuleService.getWeekName(key);
            },

            /**
             * 得到限制对象类型
             * @returns {*|{[p: string]: string, [p: number]: string}}
             */
            getAllowTypes() {
                return LoginRuleService.getAllowTypes();
            },

            /**
             * 根据选择type的切换动态去异步获取 Select Options 数据
             **/
            getSelectOptions(type) {
                let val = parseInt(type);
                switch (val) {
                    case TYPE_USERS:
                            UserService.getAll({
                                fields: "id,name",
                                scenario: "all-user"
                            }).then(res => {
                                if (res.code == 0) {
                                    this.users = res.data
                                }
                            })
                        break;
                    case TYPE_BRANCHES:
                        CommonService.getLastBranches().then(res => {
                            if (res.code == 0) {
                                this.branches = res.data;
                            }
                        })
                        break;
                    case TYPE_ROLE:
                        CommonService.getAllRoles().then(res => {
                            if (res.code == 0) {
                                this.roles = res.data;
                            }
                        });
                        break;
                    default:
                        return;
                        break;
                }
            },

            submitForm() {

                this.$refs["form"].validate(valid => {
                    if (valid) {

                        if (![TYPE_USERS, TYPE_BRANCHES, TYPE_ROLE].includes(parseInt(this.model.type))) {
                            this.$message.error('请正确选择需要限制的对象 !');
                            return false;
                        }

                        if (this.model.allow_range.length < 1) {
                            this.$message.error('请正确选择' + LoginRuleService.getAllowTypeName(this.model.type));
                            return false;
                        }

                        for (var week in this.model.allow_times) {
                            if (this.model.allow_times[week]) {
                                let time = this.model.allow_times[week];
                                if (time.start_at == '' || time.end_at == '') {
                                    this.$message.error('选择限制时间周次后，开始结束时间不允许为空!');
                                    return false;
                                }
                            }
                        }

                        if (this.scenario == 'create') {
                            LoginRuleService.create(this.model).then(res => {
                                if (res.code == 0) {
                                    this.$message.success('创建成功!');
                                    this.$router.push({path: "/login-rules/index"});
                                }
                            });
                        } else if (this.scenario == 'update' && this.model.id > 0) {
                            LoginRuleService.update(this.model).then(res => {
                                if (res.code == 0) {
                                    this.$message.success('更新成功!');
                                    this.$router.push({path: "/login-rules/index"});
                                }
                            })
                        }

                        return true;
                    } else {
                        return false;
                    }
                })

            },

            /**
             * 清空限制范围
             * 在编辑状态下如果切换 type 那么就应该把上一个 type 对应的 allow_range 清空避免造成数据错误
             * 比如 在 type = 1 时 选择了用户 [1, 2]  但是在 type=2 的时候 并没有包含 [1,2] 的数据
             */
            clearAllowRange() {
                if (this.model.allow_range.length > 0) {
                    for (var i in this.model.allow_range) {
                        this.model.allow_range.splice(i);
                    }
                }
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/login-rules/form.vue